export enum ImageCropAspectRatio {
  FREE,
  CROP_1_1 = 'square',
  CROP_16_9 = 'wide',
  CROP_21_9 = 'promo-wide',
  CROP_30_9 = 'promo-wide-large',
  CROP_2_3 = 'poster',
}
